const ACCESS = 'domcrm_staff_new_access';
const REFRESH = 'domcrm_staff_new_refresh';
const IMPERSONATE = 'domcrm_staff_new_impersonate_org';
const SUPERADMIN_NO_ORG = 'domcrm_staff_new_superadmin_no_org';

export function getStoredAccessToken(): string | null {
  try {
    return localStorage.getItem(ACCESS);
  } catch {
    return null;
  }
}

export function setStoredAccessToken(token: string | null): void {
  try {
    if (token) localStorage.setItem(ACCESS, token);
    else localStorage.removeItem(ACCESS);
  } catch {
    /* ignore */
  }
}

export function getStoredRefreshToken(): string | null {
  try {
    return localStorage.getItem(REFRESH);
  } catch {
    return null;
  }
}

export function setStoredRefreshToken(token: string | null): void {
  try {
    if (token) localStorage.setItem(REFRESH, token);
    else localStorage.removeItem(REFRESH);
  } catch {
    /* ignore */
  }
}

export function getStoredImpersonateOrgId(): number | null {
  try {
    const v = localStorage.getItem(IMPERSONATE);
    if (!v) return null;
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch {
    return null;
  }
}

export function setStoredImpersonateOrgId(id: number | null): void {
  try {
    if (id != null && id > 0) localStorage.setItem(IMPERSONATE, String(id));
    else localStorage.removeItem(IMPERSONATE);
  } catch {
    /* ignore */
  }
}

export function getStoredSuperadminNoOrg(): boolean {
  try {
    return localStorage.getItem(SUPERADMIN_NO_ORG) === '1';
  } catch {
    return false;
  }
}

export function setStoredSuperadminNoOrg(enabled: boolean): void {
  try {
    if (enabled) localStorage.setItem(SUPERADMIN_NO_ORG, '1');
    else localStorage.removeItem(SUPERADMIN_NO_ORG);
  } catch {
    /* ignore */
  }
}

export function clearAuthSession(): void {
  setStoredAccessToken(null);
  setStoredRefreshToken(null);
  setStoredImpersonateOrgId(null);
  setStoredSuperadminNoOrg(false);
}
